import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { manufacturerApi } from '../api/manufacturer-api';
import type { ManufacturerProfile, UpdateProfileRequest } from './types';

export const manufacturerKeys = {
  all: ['manufacturer'] as const,
  profile: () => [...manufacturerKeys.all, 'profile'] as const,
};

export function useProfileQuery() {
  return useQuery({
    queryKey: manufacturerKeys.profile(),
    queryFn: () => manufacturerApi.getProfile(),
    staleTime: 60_000,
  });
}

export function useUpdateProfileMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateProfileRequest) => manufacturerApi.updateProfile(body),
    onSuccess: (profile: ManufacturerProfile) => {
      // Set immediately so the UI reflects the new state without a flash, then
      // invalidate so a fresh GET reconciles anything the PUT response omitted
      // (e.g. server-derived fields or partial responses).
      qc.setQueryData(manufacturerKeys.profile(), profile);
      void qc.invalidateQueries({ queryKey: manufacturerKeys.profile() });
    },
  });
}

export function useSubmitKycMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => manufacturerApi.submitKyc(),
    onSuccess: (profile: ManufacturerProfile) => {
      qc.setQueryData(manufacturerKeys.profile(), profile);
    },
  });
}
